export const BREAKPOINT_XS = "400px";
export const BREAKPOINT_SM = "640px";
export const BREAKPOINT_MD = "768px";
export const BREAKPOINT_LG = "1024px";
export const BREAKPOINT_XL = "1280px";
export const BREAKPOINT_2XL = "1536px";
